export const INSTALLED_STATUSES = {
  Altered: 0,
  Inspected: 1,
  Modified: 2,
  New: 3,
  "Not Specified": 4,
  Overhauled: 5,
  "Other (See Notes)": 6,
  Repaired: 7,
  Rebuilt: 8,
  Servisable: 9,
};
